import { useTranslation } from "react-i18next"
import CreateStorageForm from "features/storages/createStorageForm"
import Callout from "components/callout/callout"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import PageTitle from "features/navigation/pageTitle"
import RightSidebar from "@/components/sidebar/right/RightSidebar"

const CreateStoragePage = () => {

    const { t } = useTranslation()

    return (
        <>
            <PageTitle title={t('titleCreateStorage')} />
            <Callout type={`info`} id="createStorageInfo" title={t(`titleTips`)} className={`mx-1`}>{t('createStorageInfo')}</Callout>
            <Section>
                <CreateStorageForm />
            </Section>
            <RightSidebar />
        </>
    )
}

export default CreateStoragePage

